module.exports = __webpack_public_path__ + "static/media/gb.bd749493.svg";